import { connect } from 'react-redux'
import actions from 'actions/dashboardTemplates'
import { createAuthStateToProps } from 'helpers/auth'
import Component from 'components/DashboardViewer/Dashboard'

const mapStateToProps = (state, props) => ({ ...createAuthStateToProps(state, props) })

const mapDispatchToProps = {
  getTemplate: actions.getItem,
  updateTemplate: actions.updateItem,
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)
